<template>
    <div class="day-month-btn f-inlineblock-top">
        <span class="dmb-con profit-day-btn-r js-day-btn" :class="{off: isActive,on:!isActive}" @click="switchOff">{{ switchData[0].name}}</span>
        <span class="dmb-con profit-month-btn-r js-month-btn" :class="{on:isActive,off: !isActive}" @click="switchOn">{{ switchData[1].name}}</span>
    </div>
</template>
<!--
  <switch-button :switchData="switchData" :switch.sync="switchValue"></switch-button>
  参数
    switchData:[{name: '天',value:1},{name:'地',value:2}],
-->
<style lang="scss" scoped>
    @import '~Assets/sass/pages/v4/profit/profit.scss';
     .profit-month-btn-r {
        margin-left: -10px;
    }
    .dmb-con{ width: 41px}
    .off {
        background: transparent;
        color: #FD7E28;
    }
    .on{
        background: #FD7E28;
        color: #fff;
    }
</style>
<script>
export default {
    props: ['switchData'],
    data () {
        return {
            isActive: false
        }
    },
    components: {},
    mounted(){
    },
    methods: {
        switchOn() {
            this.isActive = true;
            this.$emit('switchVal', this.switchData[1].value);
        },
	        switchOff() {
		        this.isActive = false;
		        this.$emit('switchVal', this.switchData[0].value);
	        }


    }
}
</script>
